import { Injectable } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

export enum SheetViewCarouselTrackingValues {
    EventCarousel = 'event carousel',
    Click = 'click',
    SheetView = 'sheet view',
    Subnavigation = 'sub-navigation',
}
export enum SheetViewCarouselTrackingType {
    EventCarouselClick = 'eventcarousel',
    TabBarClick = 'tabbar',
}
@Injectable()
export class SheetViewCarouselTrackingService {
    constructor(
        private trackingService: TrackingService,
        private urlHelper: UrlHelperService,
    ) {}

    trackEventCarousel(expression: string, event: EventModel, marketName: string, tabTitle?: string, index?: number): void {
        switch (expression) {
            case SheetViewCarouselTrackingType.EventCarouselClick:
                this.trackEventCarouselClick(event, marketName, index);
                break;
            case SheetViewCarouselTrackingType.TabBarClick:
                this.trackEventCarouselTabBarClick(event, marketName, tabTitle, index);
                break;
        }
    }

    private trackEventCarouselClick(event: EventModel, marketName: string, contentPosition?: number): void {
        const eventDetailText = event.name;

        const trackingData = {
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventDetailText,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            ...this.getCommanTrackData(event, marketName, contentPosition),
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    private trackEventCarouselTabBarClick(event: EventModel, marketName: string, tabTitle?: string, contentPosition?: number): void {
        const eventDetailText = event.name;

        const trackingData = {
            [trackingConstants.COMPONENT_POSITION_EVENT]: SheetViewCarouselTrackingValues.Subnavigation + '-' + eventDetailText,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: tabTitle,
            ...this.getCommanTrackData(event, marketName, contentPosition),
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    private getEventUrl(eventId: string, eventName: string): string {
        return this.urlHelper.getEventUrl({ id: eventId, name: eventName });
    }

    private getCommanTrackData(event: EventModel, marketName: string, contentPosition?: number) {
        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: SheetViewCarouselTrackingValues.EventCarousel,
            [trackingConstants.COMPONENT_LABEL_EVENT]: marketName,
            [trackingConstants.COMPONENT_ACTION_EVENT]: SheetViewCarouselTrackingValues.Click,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: SheetViewCarouselTrackingValues.SheetView,
            [trackingConstants.COMPONENT_URL_CLICKED]: this.getEventUrl(event.id, event.name),
            [trackingConstants.COMPONENT_CONTENT_POSITION]: contentPosition,
            [trackingConstants.SPORT_EVENT_ID]: event.id,
        };

        return trackingData;
    }
}
